<header></header>

@let state = loadState$ | async;

<div class="referrals-page mx-auto p-4 p-md-0 pt-md-8 pb-md-10" data-id="referrals-page">
  @if (state?.status === 'loading' || state?.status === 'idle') {
    <ds-skeleton [width]="280" [height]="32" />
    <ds-skeleton class="mt-4" [height]="120" />
    <ds-skeleton class="mt-4" [height]="200" />
  } @else if (state?.status === 'error') {
    <h1 class="semi-bold">Referrals</h1>
    <p class="mt-4">We could not load your referral program details. Please try again.</p>
    <ds-button (click)="retry()" label="Try again" class="mt-4" data-id="referral-retry" />
  } @else if (state && isReadyState(state)) {
    @let program = state.data;

    @if (!program.hasAccess) {
      <h1 class="semi-bold">Referrals</h1>
      <p class="mt-4" data-id="referral-ineligible">
        The referral program is not available for your account at this time. If you believe this is
        an error, please contact your BCC travel expert.
      </p>
    } @else {
      <referral-program-hero [program]="program" />

      @if (program.referrals && program.referrals.length) {
        <h2 class="referrals-page__section-title semi-bold mt-8">Active invites</h2>

        <div class="referrals-list mt-4 d-flex flex-column g-3">
          @for (referral of program.referrals; track trackReferral($index, referral)) {
            <button
              type="button"
              class="referrals-list-item"
              (click)="openReferralDetail(referral)"
              data-id="referral-list-row"
            >
              <span class="referrals-list-item__avatar" aria-hidden="true">{{
                referralInitials(referral.maskedName)
              }}</span>

              <span class="referrals-list-item__main text-start">
                <span class="referrals-list-item__name d-block" data-id="referral-masked-name">{{
                  referral.maskedName
                }}</span>
                <span
                  class="referrals-list-item__status"
                  data-id="referral-status"
                  [class.referrals-list-item__status--success]="
                    referral.displayStatus === PortalReferralDisplayStatus.SUCCESS
                  "
                >
                  {{ referralDisplayStatusLabel(referral.displayStatus) }}
                </span>
              </span>

              <span class="referrals-list-item__meta">
                @if (
                  showDaysLeftToBook(referral.displayStatus) &&
                  referral.daysLeftToBook !== null &&
                  referral.daysLeftToBook !== undefined
                ) {
                  <span class="referrals-list-item__pill" data-id="referral-days-left">
                    {{ referral.daysLeftToBook }} days left to book
                  </span>
                } @else if (
                  referral.displayStatus === PortalReferralDisplayStatus.SUCCESS &&
                  referral.rewardAmount
                ) {
                  <span class="referrals-list-item__reward" data-id="referral-reward">
                    +{{ referral.rewardAmount | portalCurrency: true }}
                  </span>
                }
              </span>
            </button>
          }
        </div>
      }

      <referral-how-it-works
        class="mt-8 d-block"
        [rewardAmount]="program.rewardAmount"
        [refereeWindowDays]="program.refereeWindowDays"
      />

      <referral-faq-section class="mt-8 d-block" />

      <need-help-card class="mt-6 mt-md-8 d-block" />
    }
  }
</div>

<footer></footer>

<ng-template #referralDetailTemplate>
  @if (selectedReferral) {
    <referral-detail-modal [referral]="selectedReferral" (close)="closeReferralDetail()" />
  }
</ng-template>
